import { Add, ArrowBack, Close, Search } from '@mui/icons-material';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  InputAdornment,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Slide,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { openNotification } from '../../../../helpers/notification';
import { userCategories, userCats } from '../../../../helpers/appstate';
import { AssignConsultantToFacility, getConsultantsV2, inviteUsers } from '../../../../helpers/api';
import LoaderSkeleton from '../../../common/LoaderSkeleton';
import { Empty } from 'antd';
import { EyeFilled } from '@ant-design/icons';

export default function ConsultantInvite({ open, onClose, facilityId }) {
  const userCategory = userCategories?.find((x) => x.name === userCats.CONSULTANT).id;

  const screen = { all: 'all', selected: 'selected' };

  const [sending, setSending] = useState(false);

  const [consultantList1, setConsultantList1] = useState([]);
  const [consultantList2, setConsultantList2] = useState([]);
  const [consultantLoading, setConsultantLoading] = useState(false);
  const [consultantsSelected, setConsultantsSelected] = useState([]);
  const [searchParam, setSearchParam] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [previewScreen, setPreviewScreen] = useState(screen.all);
  const [dialogInvite, setDialogInvite] = useState(false);

  useEffect(() => {
    fetchConsultantList();
  }, []);

  useEffect(() => {
    if (refresh) {
      fetchConsultantList();
    }
  }, [refresh]);

  useEffect(() => {
    setConsultantList2(consultantList1);
  }, [consultantList1]);

  useEffect(() => {
    handleSearchFacility(searchParam);
  }, [searchParam]);

  const handleSearchFacility = (value) => {
    if (!value) {
      setConsultantList2(consultantList1);
    } else {
      const filter = consultantList1?.filter(
        (x) =>
          x?.email?.toLowerCase().includes(value?.toLowerCase()) ||
          x?.fullName.toLowerCase().includes(value?.toLowerCase())
      );

      setConsultantList2(filter);
    }
  };

  const handleSelectDeselectFacility = (item) => {
    const exists = consultantsSelected?.find((x) => x?.userId === item?.userId);
    if (exists) {
      const filtered = consultantsSelected?.filter((x) => x?.userId !== item?.userId);
      setConsultantsSelected(filtered);
    } else {
      setConsultantsSelected((prev) => [...prev, item]);
    }
  };

  const handleClearSearch = () => {
    setSearchParam('');
  };

  const fetchConsultantList = async () => {
    setConsultantLoading(true);
    try {
      const res = await getConsultantsV2(searchParam, 0, 10000);
      console.log(res);
      const { totalCount, data, status } = res?.result;
      if (status?.code === '00') {
        setConsultantList1(data);
        // setTotalCount(totalCount);
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      openNotification({ type: 'error', message: 'Something went wrong. Please try again' });
    } finally {
      setConsultantLoading(false);
      setRefresh(false);
    }
  };

  const handleSendInvite = async () => {
    setSending(true);
    try {
      const consultantPayloadList = consultantsSelected?.map((i) => {
        return {
          consultantId: i?.userId,
          comment: '',
        };
      });
      const payload = {
        facilityId: facilityId,
        consultant: consultantPayloadList,
      };

      const res = await AssignConsultantToFacility(payload);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
        setDialogInvite(false);
      }
    } catch (error) {
      const errmsg = error?.data?.result?.status?.desc;
      console.log(error);
      openNotification({ type: 'error', message: errmsg });
    } finally {
      setSending(false);
    }
  };

  const handleRenderContent = () => {
    if (consultantLoading) {
      return (
        <Box>
          <LoaderSkeleton />
          <br />
          <LoaderSkeleton />
        </Box>
      );
    } else {
      if (consultantList1?.length < 1) {
        return (
          <Box
            sx={{
              height: '400px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Empty />
            <br />
            <Typography>
              {`If you have not searched for a facility, please search for one to see result`}
            </Typography>
          </Box>
        );
      } else {
        return renderContent();
      }
    }
  };

  const renderContent = () => {
    if (previewScreen === screen.all) {
      return renderAllConsultants();
    } else if (previewScreen === screen.selected) {
      return renderSelectedConsultants();
    }
  };

  const renderAllConsultants = () => {
    return (
      <Box
        sx={{
          mt: 2,
          height: '250px',
          overflowY: 'scroll',
          // borderBottom: 1,
          // borderColor: 'divider',
        }}
      >
        {consultantList2?.map((i) => {
          const isSelected = !!consultantsSelected?.find((x) => x?.userId === i?.userId);

          return (
            <ListItemButton
              key={i?.userId}
              sx={{
                border: 1,
                borderColor: 'divider',
                bgcolor: isSelected ? '#d0e9fa' : null,
                mb: 1,
                py: 0.5,
              }}
              onClick={() => handleSelectDeselectFacility(i)}
            >
              <ListItemAvatar>
                <Avatar></Avatar>
              </ListItemAvatar>
              <ListItemText>
                <Typography variant="body2">{i?.fullName}</Typography>
                <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.8rem' }}>
                  {i?.email}
                </Typography>
              </ListItemText>
            </ListItemButton>
          );
        })}
      </Box>
    );
  };

  const renderSelectedConsultants = () => {
    return (
      <Slide direction="left" in={previewScreen === 'selected'} mountOnEnter unmountOnExit>
        <Box sx={{ height: '300px', overflowy: 'scroll' }}>
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title="Back">
                <IconButton onClick={() => setPreviewScreen(screen.all)}>
                  <ArrowBack />
                </IconButton>
              </Tooltip>
              <Box>
                <Typography fontWeight={600} color="textSecondary" variant="h6">
                  Selected consultants
                </Typography>
              </Box>
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setDialogInvite(true)}
              sx={{ textTransform: 'none', ml: 'auto' }}
            >
              Invite Selected
            </Button>
          </Box>

          <Box>
            {consultantsSelected?.map((i) => {
              return (
                <ListItemButton
                  key={i?.userId}
                  sx={{
                    border: 1,
                    borderColor: 'divider',
                    bgcolor: '#d0e9fa',
                    mb: 1,
                    py: 0.5,
                  }}
                  onClick={() => handleSelectDeselectFacility(i)}
                >
                  <ListItemAvatar>
                    <Avatar></Avatar>
                  </ListItemAvatar>
                  <ListItemText>
                    <Typography variant="body2">{i?.fullName}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.8rem' }}>
                      {i?.email}
                    </Typography>
                  </ListItemText>
                </ListItemButton>
              );
            })}
          </Box>
        </Box>
      </Slide>
    );
  };

  return (
    <Box>
      <Dialog open={open} maxWidth="sm" fullWidth>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
            Invite Consultants
          </DialogTitle>
          <Box ml="auto" px={3}>
            <IconButton onClick={() => onClose()} disabled={sending}>
              <Close />
            </IconButton>
          </Box>
        </Box>
        <DialogContent sx={{ pb: 6 }}>
          <Alert severity="info" icon={false}>
            {`Provide the email addresses of Consultants you wish to consult for your facility. Note
          that the System Administrator will preview them`}
          </Alert>
          <br />

          {previewScreen === screen.all && (
            <Box>
              <Box sx={{ mb: 2 }}>
                <TextField
                  placeholder="Search consultant's email or full name"
                  value={searchParam}
                  onChange={(e) => setSearchParam(e.target.value)}
                  fullWidth
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      ),
                      endAdornment: searchParam && (
                        <InputAdornment position="end">
                          <IconButton onClick={handleClearSearch}>
                            <Close />
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </Box>

              {consultantsSelected?.length > 0 && (
                <Box sx={{ display: 'flex', mb: 2 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setDialogInvite(true)}
                    sx={{ textTransform: 'none' }}
                  >
                    Invite Selected
                  </Button>

                  <Button
                    variant="text"
                    color="primary"
                    endIcon={<EyeFilled />}
                    onClick={() => setPreviewScreen('selected')}
                    sx={{ textTransform: 'none', ml: 'auto' }}
                  >
                    {consultantsSelected?.length} Selected
                  </Button>
                </Box>
              )}
            </Box>
          )}

          {handleRenderContent()}
        </DialogContent>
      </Dialog>

      {dialogInvite && (
        <Dialog open={open} maxWidth="xs" fullWidth>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box ml="auto" p={1}>
              <IconButton onClick={() => setDialogInvite(false)} disabled={sending}>
                <Close />
              </IconButton>
            </Box>
          </Box>
          <DialogContent>
            <Typography>
              {` Are you sure you want to Invite the selected consultant(s) to your facility`}
            </Typography>
          </DialogContent>{' '}
          <DialogActions sx={{ px: 2, pb: 3 }}>
            <Button
              type="button"
              variant="contained"
              color="info"
              disabled={sending}
              startIcon={sending && <CircularProgress size={20} />}
              onClick={handleSendInvite}
              sx={{ textTransform: 'none', borderRadius: 20 }}
            >
              Yes, Send Invite
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
}
